
import { Component, Inject, Vue } from "vue-property-decorator";
import LoadingOverlay from "../../../../common/src/components/LoadingOverlay.vue";
import NoRecords from "../../../../common/src/components/NoRecords.vue";
import orderBy from "lodash.orderby";
import { Container } from "inversify";
import { OrganizationListStore } from "../../stores/organization/OrganizationListStore";
import { OrganizationListItem } from "@gsx/common/src/types/http/dashboard/organization";
import { Action } from "vuex-class-modules";

@Component({
    components: { NoRecords, LoadingOverlay },
})
export default class RecentlyFoundedOrganizationList extends Vue {
    @Inject("container") readonly container!: Container;
    organizationListStore: OrganizationListStore = this.container.get(OrganizationListStore);
    pageSize = 10;
    page = 1;

    get pageCount(): number {
        return Math.max(1, Math.ceil(this.getFiltered().length / this.pageSize));
    }

    @Action
    async changePage(page: number) {
        this.page = page;
    }

    getFiltered() {
        const items = this.organizationListStore.filteredItems
            ? this.organizationListStore.filteredItems
            : [];
        return items.filter(
            (organization) => organization.dateYearFounded && organization.dateYearFounded > 2020,
        );
    }

    get lastUpdatedOrganizations() {
        return orderBy(
            this.getFiltered(),
            ["dateYearFounded", "dateMonthFounded"],
            ["desc", "desc"],
        ).slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
    }

    getFoundedAt(organization: OrganizationListItem): string {
        if (organization.dateYearFounded) {
            if (organization.dateMonthFounded) {
                const month = String(organization.dateMonthFounded).padStart(2, "0");
                return `${month}/${organization.dateYearFounded}`;
            }

            return String(organization.dateYearFounded);
        }

        return "n/a";
    }
}
